import useBreakpoint from '@/hooks/useBreakpoint';
import FooterCorpoMobile from './Designs/Mobile';
import FooterCorpoDesktop from './Designs/Desktop';

export default function FooterCorpo() {
  const { breakpoint } = useBreakpoint();
  return breakpoint === 'mobile' ? (
    <FooterCorpoMobile />
  ) : (
    <FooterCorpoDesktop />
  );
}
